import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Breadcrumb } from "antd";
import { useTranslation } from "react-i18next";

export default function RolesCreateBreadcrumb() {
  const navigate = useNavigate();
  const location = useLocation();
  const [t] = useTranslation("global");

  // The three dedicated role routes (create / edit / view) share one sidebar
  // tab, so the last crumb is resolved from the path instead of the tab.
  const currentActionLabel = () => {
    if (location.pathname.includes("/roles/view/")) {
      return t("organizationManagement.viewRole");
    }
    if (location.pathname.includes("/roles/edit/")) {
      return t("organizationManagement.editRole");
    }
    return t("organizationManagement.createNewRole");
  };

  const navigateToRoles = () => {
    navigate({
      pathname: "/organization-management/roles",
    });
  };

  return (
    <Breadcrumb className="">
      <Breadcrumb.Item>{t("header.organizationManagement")}</Breadcrumb.Item>
      <Breadcrumb.Item
        onClick={() => {
          navigateToRoles();
        }}
        className="generalStyles__breadcrumbItemInactive"
      >
        {t("header.roles")}
      </Breadcrumb.Item>
      <Breadcrumb.Item className="generalStyles__breadcrumbItem">
        {currentActionLabel()}
      </Breadcrumb.Item>
    </Breadcrumb>
  );
}
